import { ProjectTag } from "./Common";
import { MilestoneStatus, ProjectStatuses, TicketStatuses } from "./Status";

export const TaskStatusColor = (status) => {
    switch (status) {
      case TicketStatuses.DRAFT:
        return "draftStatus";
      case TicketStatuses.TO_DO:
        return "todoStatus";
      case TicketStatuses.IN_PROGRESS:
        return "inProgressStatus";
      case TicketStatuses.IN_QA:
        return "inQaStatus";
      case TicketStatuses.IN_APPROVAL:
        return "inApprovalStatus";
      case TicketStatuses.DONE:
        return "doneStatus";
      case TicketStatuses.REJECTED:
        return "rejectedStatus";
      default:
        return "ongoingStatus";
    }
  };

  export const ProjectStatusColor = (status) => {
    switch (status) {
      case ProjectStatuses.DRAFT:
      case ProjectTag.INACTIVE:
        return "badge-default";
      case ProjectStatuses.IN_APPROVAL:
        return "badge-warning";
      case ProjectStatuses.ONGOING:
        return "badge-info";
      case ProjectStatuses.SENT_FOR_CONFIRMATION:
        return "badge-warning";
      case ProjectStatuses.APPROVED:
      case ProjectTag.ACTIVE:
        return "badge-success";
      case ProjectStatuses.REJECTED:
      case ProjectStatuses.CONFIRMATION_REJECTED:
      case ProjectTag.STOP:
        return "badge-danger";
      case ProjectStatuses.COMPLETED:
        return "badge-success";
      default:
        return "badge-secondary";
    }
  };

  export const MilestoneStatusColor = (status) => {
    switch (status) {
      case MilestoneStatus.DRAFT:
        return "badge-default";
      case MilestoneStatus.IN_APPROVAL:
        return "badge-warning";
      case MilestoneStatus.ONGOING:
        return "badge-info";
      case MilestoneStatus.SENT_FOR_CONFIRMATION:
        return "badge-warning";
      case MilestoneStatus.REJECTED:
        return "badge-danger";
      case MilestoneStatus.CONFIRMATION_REJECTED:
        return "badge-danger";
      case MilestoneStatus.DONE:
        return "badge-success";
      default:
        return "badge-secondary";
    }
  };